import { DateTime } from "luxon";

import { ILead, LeadSource, QuoteType } from "../../../../models/Lead";
import PriceFormat from "../../../../utils/priceFormat";
import formatDateTime from './../../../../utils/formatDateTime';
import SendQualifierButton from "../../SendQualifierButton";
import { GetQuoteType } from "../../LeadInformation/QuoteCalculationCard";

export default function LeadsTableSubComponent({ lead }: { lead: ILead }) {


  return (
    <>
      <div className="flex justify-between bg-gray-100 pl-28 p-4">
        <div className="flex gap-x-10">
          <div className="flex flex-col">
            <span className="font-bold">Price</span>
            <span>{PriceFormat(lead.price)}</span>
          </div>

          {lead.applyVAT && (
            <div className="flex flex-col">
              <span className="font-bold">With VAT</span>
              <span>{PriceFormat(lead.priceWithVAT)}</span>
            </div>
          )}

          <div className="flex flex-col">
            <span className="font-bold">Website</span>
            <span>{LeadSource[lead.website]}</span>
          </div>

          {(lead.website == LeadSource.SellAVehicle || lead?.website == LeadSource.Widget) && (
            <div className="flex flex-col">
              <span className="font-bold">Quote Type</span>
              <span>{GetQuoteType(lead.quoteType)}</span>
            </div>
          )}

          <div className="flex flex-col">
            <span className="font-bold">Exported</span>
            <span className="flex justify-center">{lead.exportedOn !== null ? "✔" : "X"}</span>
          </div>

          <div className="flex flex-col">
            <span className="font-bold">Created</span>
            <span className="flex justify-center">{formatDateTime(lead.created, DateTime.DATE_SHORT)}</span>
          </div>

          <div className="flex flex-col">
            <span className="font-bold">Engine Price</span>
            <span>
              {lead.vehicle?.enginesWorldwideEngineOffer ?
                PriceFormat(parseFloat(lead.vehicle?.enginesWorldwideEngineOffer))
                : "N/A"
              }
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-bold">Front-end Price</span>
            <span>
              {lead.vehicle?.enginesWorldwideVfeOffer ?
                PriceFormat(parseFloat(lead.vehicle?.enginesWorldwideVfeOffer))
                : "N/A"
              }
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-bold">Average Catalytic Price</span>
            <span>
              {lead.vehicle?.enginesWorldwideVfeOffer ?
                PriceFormat(parseFloat(lead.catalyticAveragePrice?.toString()!))
                : "N/A"
              }
            </span>
          </div>
        </div>

        <div className="flex items-center">
          {/* <ButtonInput label={"Send Qualifier Text"} isSubmit={false} onClick={handleQualifyText} classes="" /> */}
          <SendQualifierButton lead={lead} />
        </div>

      </div>
    </>
  )
}